<script>
import * as d3 from 'd3'
import chart from '@/mixins/chart'

const categories = {
  DOJ: { label: 'In the U.S. DOJ agreement', color: '#C69C5C' },
  LD: { label: 'In the Ericsson List files', color: '#852508' },
  DOJLD: { label: 'In both', color: '#837B7B' }
}

export default {
  mixins: [chart],
  name: 'ChartAllegedCorruptPraticesByCountry',
  filters: {
    formatNumber: d3.format(',')
  },
  computed: {
    csv () {
      return this.$options.csv
    },
    csvWithCategoryLabels () {
      return this.csv.map(i => {
        const { label: category, color } = categories[i.category]
        return { ...i, category, color }
      })
    }
  }
}
</script>
<template>
  <div class="chart-practice-by-country p-4">
    <h4>{{ chartRoute.title }}</h4>
    <p class="mb-3">
      As Ericsson was entering into a deferred prosecution agreement with the U.S. Department of Justice about corrupt practices in five countries, the company was investigating allegations of impropriety in more than a dozen other countries, leaked documents reveal.
    </p>
    <symbol-map
      :markers-width="7"
      :social-mode="socialMode"
      :data="csvWithCategoryLabels"
      horizontal-legend
      class="chart-practice-by-country__map mb-3">
    </symbol-map>
    <p class="text-muted text-right small mb-0">
      Source: U.S. Dept. of Justice; the Ericsson List documents.
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import '../variables.scss';

.chart-practice-by-country {
  overflow: hidden;
  min-height: 500px;
  height: 100%;
  width: 100%;
  position: relative;

  background: white no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;

  .chart--social-mode & {
    background-color: #616161;

    &:deep(.symbol-map__main__features__item) {
      color: #323130 !important;
    }

    .text-muted {
      color: rgba($light, 0.5) !important;
    }
  }

  .chart--active-route-view & {
    height: calc(100vh - var(--app-footer-height, 0));
  }

  &__map {
    flex-grow: 1;
    position: static;

    &:deep(.ordinal-legend) {
      margin: 0;
    }

    &:deep(.symbol-map__main__features__item) {
      color: $light !important;
    }
  }
}
</style>

<csv>
label,latitude,longitude,category,iso3
Angola,-12.180859,17.996347,LD,AGO
Indonesia,-1.003189,101.972332,DOJ,IDN
Azerbaijan,40.402387,47.210994,LD,AZE
Bahrain,26.020458,50.551925,LD,BHR
Brazil,-11.928923,-49.542449,LD,BRA
China,32.523743,106.431983,DOJLD,CHN
Croatia,45.805356,16.375139,LD,HRV
Djibouti,11.927315,42.454406,DOJ,DJI
Egypt,26.42231,29.227089,LD,EGY
Iraq,32.765286,43.614805,LD,IRQ
Kuwait,29.422226,47.330015,DOJ,KWT
Lebanon,34.095838,35.95658,LD,LBN
Libya,26.666955,18.030248,LD,LBY
Morocco,31.649504,-7.189711,LD,MAR
Portugal,39.225448,-8.266333,LD,PRT
South Africa,-29.708985,23.666291,LD,ZAF
Spain,40.09095,-3.464618,LD,ESP
United States, 38.82652,-77.01712,LD,USA
Vietnam,21.732568,105.396672,DOJ,VNM
</csv>
